<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9">
      <div class="row">
        <div class="col-lg-12">
          <div class="card shadow">
            <div class="card-header">
              <div class="mx-3 my-2">
                <h3 class="modal-title">Solicita una devolución</h3>
              </div>
            </div>
            <div class="card-body mx-3">
              <h3 class="pb-4">Artículos a devolver</h3>
              <div class="row">
                <form class="col-xl-5" @submit.prevent="agregarArticulo()">
                  <div class="form-group row items-center">
                    <div class="col-xl-2">
                      <label class="form-control-label">Factura</label>
                    </div>
                    <div class="col-xl-10">
                      <multiselect
                        v-model="facturaSelectedDevolucion"
                        :options="facturasList"
                        placeholder="Selecciona una factura"
                        label="DocNum"
                        track-by="DocNum"
                        @select="dispatchActionSelectFacturaDevolucion"
                        :loading="facturasList.length === 0">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group row items-center">
                    <div class="col-xl-2">
                      <label class="form-control-label">Artículo</label>
                    </div>
                    <div class="col-xl-10">
                      <multiselect
                        v-model="articuloSelectedDevolucion"
                        :options="articulosList"
                        placeholder="Selecciona un artículo"
                        label="ItemCode"
                        track-by="ItemCode"
                        :disabled="!facturaSelectedDevolucion || articulosList.length == 0"
                        :loading="facturaSelectedDevolucion && articulosList.length == 0">
                      </multiselect>
                    </div>
                  </div>
                  <div class="form-group row items-center">
                    <div class="col-xl-2">
                      <label class="form-control-label">Cantidad</label>
                    </div>
                    <div class="col-xl-10">
                      <input v-model="articuloCantidadDevolucion"
                             type="Number"
                             min="1"
                             required
                             class="mb-0 form-control"
                             placeholder="Cantidad de artículos">
                    </div>
                  </div>
                  <div class="form-group text-right">
                    <base-button
                        type="default"
                        :disabled='false'
                        nativeType="submit">
                      Agregar Artículo 
                      <i class="fa fa-arrow-right ml-2"></i>
                    </base-button>
                  </div>
                </form>
                <div class="col-xl-7">
                  <div v-if="articulosParaDevolver.length > 0">
                    <div class="table-responsive">
                      <base-table thead-classes="thead-light" :data="articulosParaDevolver" class="border">
                        <template v-slot:columns>
                          <th>Factura</th>
                          <th>Artículo</th>
                          <th>Cantidad</th>
                          <th></th>
                        </template> 
                        <template v-slot:default="{row, index}">
                          <th scope="row">{{row.factura}}</th>
                          <th scope="row">{{row.ItemDescription}} <br> {{row.ItemCode}}</th>
                          <th scope="row">{{row.cantidad}}</th>
                          <th scope="row" class="text-right">
                            <base-button icon="far fa-trash-alt" 
                                         type="danger"
                                         iconOnly
                                         @click="deleteArticuloParaDevolver(index)">
                            </base-button>
                          </th>
                        </template>
                      </base-table>
                    </div>
                  </div>
                  <div v-if="!(articulosParaDevolver.length > 0)" class="w-100 h-100 d-flex justify-content-center align-items-center">
                    <div>
                      <center><i class="fa fa-lg fa-plus text-muted" aria-hidden="true"></i></center>
                      <br>
                      <p class="text-muted">No hay artículos seleccionados</p>
                    </div>
                  </div>
                </div>
              </div>
              <hr>
              <div v-if="articulosParaDevolver.length > 0">
                <h3 class="pb-4">Dirección de recolección</h3>
                <div class="row">
                  <base-input label="Calle" v-model="recoleccion_calle" class="col-xl-4"></base-input>
                  <base-input label="Número" v-model="recoleccion_numero" class="col-xl-2"></base-input>
                  <base-input label="Colonia" v-model="recoleccion_colonia" class="col-xl-4"></base-input>
                  <base-input label="Código Postal" v-model="recoleccion_cp" class="col-xl-2"></base-input>
                  <base-input label="Alcaldía/Municipio" v-model="recoleccion_municipio" class="col-xl-4"></base-input>
                  <base-input label="Estado" v-model="recoleccion_estado" class="col-xl-4"></base-input>
                  <div class="form-group col-xl-4">
                    <label class="form-control-label">Vendedor</label>
                    <multiselect
                      v-model="vendedor"
                      :options="salesPeople"
                      placeholder="Selecciona un vendedor"
                      label="SalesEmployeeName"
                      track-by="SalesEmployeeCode">
                    </multiselect>
                  </div>
                  <div class="form-group col-xl-12" v-if="articulosParaDevolver.length > 0">
                    <label class="form-control-label">Descripción de la devolución</label>
                    <textarea class="form-control" v-model="descripcion" rows="3" placeholder="Escribe aquí el motivo de la cancelación"></textarea>
                  </div>
                </div>     
                <hr>                
                <div class="mt-4 text-right">
                  <base-button
                      :disabled="!(articulosParaDevolver.length > 0)"
                      type="success"
                      @click="crearDevolucion()">
                      Solicitar devolución
                  </base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';
  import firebase from "firebase/app";
  import "firebase/auth";
  import "firebase/firestore";
  import "firebase/database";
  import "firebase/storage";
  import moment from "moment";
  import Multiselect from "vue-multiselect";
  
  export default {
    components: {
      Multiselect
    },
    data() {
      return {
        loadingFirebaseUser: false,
        pending:false,
        user:null,
        rfc:null,
        facturasList:[],
        facturaSelectedDevolucion: null,
        articuloSelectedDevolucion: null,
        articulosList:[],
        articuloCantidadDevolucion: null,
        articulosParaDevolver:[],
        recoleccion_calle: null,
        recoleccion_numero: null,
        recoleccion_colonia: null,
        recoleccion_cp: null,
        recoleccion_municipio: null,
        recoleccion_estado: null,
        vendedor: null,
        descripcion: null,
        business_partner: null,
        salesPeople: []
      };
    },
    methods: {
      load(){
        this.rfc = localStorage.getItem("rfc");
        
        axios.get('/api/sales_persons').then(result => {
          this.salesPeople = result.data.value;
        });
        axios.get('/api/business_part/' + this.rfc).then((result) => { 
          this.business_partner = result.data.value[0];
        });

        this.loadingFirebaseUser = true;
        
        firebase
          .firestore()
          .collection("NuevosClientes")
          .where("f_rfc", "==", this.rfc)
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.size > 0) {
              this.pending = true
            } else {
              fetch("https://canplast.net:51000/api/v1/sap/GET/ListInvoices/"+this.rfc, {
                method: "GET",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              })
              .then((response) => response.json())
              .then((responseJson) => {
                this.facturasList = responseJson
              })
              .catch((error) => {
                console.error(error);
              });
            }
            this.loadingFirebaseUser = false;
        });
      },
      crearDevolucion(){
        this.$swal
            .fire({
              text: "¿Deseas enviar la solicitud de devolución?",
              showCancelButton: true,
              confirmButtonText: "Si",
              cancelButtonText: "No",
              icon:"question"
            })
            .then((response) => {
              if (response.isConfirmed) {   
                firebase
                .firestore()
                .collection("devoluciones")
                .add({
                    CardName: this.business_partner.CardName,
                    CardCode: this.business_partner.CardCode,
                    vendedor: this.vendedor ? this.vendedor.SalesEmployeeName : null,
                    descripcion_cliente: this.descripcion,
                    articulos: this.articulosParaDevolver,
                    status: "open",
                    recoleccion:{
                      calle: this.recoleccion_calle,
                      numero: this.recoleccion_numero,
                      colonia: this.recoleccion_colonia,
                      cp: this.recoleccion_cp,
                      municipio: this.recoleccion_municipio,
                      estado: this.recoleccion_estado
                    },
                    fecha: moment().format("YYYY-MM-DD HH:mm:ss"),
                    timestamp:  moment().format('x')
                })
                .then((docRef) => {
                  this.facturaSelectedDevolucion = null;
                  this.articuloSelectedDevolucion = null;
                  this.articuloCantidadDevolucion = null;
                  this.articulosParaDevolver = [];
                  this.recoleccion_calle = null;
                  this.recoleccion_numero = null;
                  this.recoleccion_colonia = null;
                  this.recoleccion_cp = null;
                  this.recoleccion_municipio = null;
                  this.recoleccion_estado = null;
                  this.vendedor = null;
                  this.descripcion = null;

                  this.$swal("", "Tu solicitud de devolución ha sido enviada al equipo de Canplast México. Un agente se pondrá en contacto contigo para el seguimiento correspondiente.", "success");
                })
                .catch(() => {
                  this.$swal("", "Hubo un error al solicitar la devolución", "error");
                });
              }
        });
      },
      deleteArticuloParaDevolver(index){
        this.articulosParaDevolver.splice(index, 1);
      },
      agregarArticulo(){
        if(this.facturaSelectedDevolucion && this.articuloSelectedDevolucion && this.articuloCantidadDevolucion){
          this.articulosParaDevolver.push({
            cantidad: this.articuloCantidadDevolucion,
            ItemCode: this.articuloSelectedDevolucion.ItemCode,
            ItemDescription: this.articuloSelectedDevolucion.ItemDescription,
            factura: this.facturaSelectedDevolucion.DocNum
          })
          this.articuloCantidadDevolucion = null;
          this.articuloSelectedDevolucion = null;         
        }
      },
      dispatchActionSelectFacturaDevolucion(data){
        this.facturaSelectedDevolucion = data
        this.articulosList = []
        this.articuloSelectedDevolucion = null
        fetch("https://canplast.net:51000/api/v1/sap/GET/DocumentLinesByInvoice/"+this.facturaSelectedDevolucion.DocNum, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
        .then((response) => response.json())
        .then((responseJson) => {
          this.articulosList = responseJson[0].DocumentLines
          if(this.articulosParaDevolver.length===0){
            this.recoleccion_calle = responseJson[0].AddressExtension.ShipToStreet
            this.recoleccion_numero = responseJson[0].AddressExtension.ShipToStreetNo
            this.recoleccion_colonia = responseJson[0].AddressExtension.ShipToBlock
            this.recoleccion_cp = responseJson[0].AddressExtension.ShipToZipCode
            this.recoleccion_municipio = responseJson[0].AddressExtension.ShipToCity
            this.recoleccion_estado = responseJson[0].AddressExtension.ShipToState
          }
          // console.log(responseJson)
        })
        .catch((error) => {
          console.error(error);
        });
      },
      moment: function () {
        return moment();
      },
    },
    mounted() {
      this.load()
    },
    created() {
      this.user = firebase.auth().currentUser;

    },
  };
</script>